// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3SinB{bottom:13px;-ms-flex:1 1;flex:1 1;left:0;margin-top:8px;padding:0 13px;position:relative;right:0;width:100%;-ms-flex-align:end;align-items:flex-end;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;color:#010101;font-family:Avenir;font-size:12px;font-style:normal;font-weight:400;justify-content:space-between;line-height:17px}", ""]);
// Exports
exports.locals = {
	"footer": "_3SinB"
};
module.exports = exports;
